import {dom, library} from "@fortawesome/fontawesome-svg-core";
import * as SolidIcons from "@fortawesome/free-solid-svg-icons";

export default function () {
    library.add(SolidIcons.faBars);
    library.add(SolidIcons.faBolt);
    library.add(SolidIcons.faCheck);
    library.add(SolidIcons.faChevronLeft);
    library.add(SolidIcons.faChevronRight);
    library.add(SolidIcons.faClock);
    library.add(SolidIcons.faClone);
    library.add(SolidIcons.faCloud);
    library.add(SolidIcons.faFileUpload);
    library.add(SolidIcons.faCloudUploadAlt);
    library.add(SolidIcons.faExclamationTriangle);
    library.add(SolidIcons.faEye);
    library.add(SolidIcons.faEyeSlash);
    library.add(SolidIcons.faFileContract);
    library.add(SolidIcons.faImage);
    library.add(SolidIcons.faLocationArrow);
    library.add(SolidIcons.faMapMarked);
    library.add(SolidIcons.faPencilAlt);
    library.add(SolidIcons.faPlus);
    library.add(SolidIcons.faSearchPlus);
    library.add(SolidIcons.faSync);
    library.add(SolidIcons.faTag);
    library.add(SolidIcons.faTrash);
    library.add(SolidIcons.faTemperatureHigh);
    library.add(SolidIcons.faTimes);
    library.add(SolidIcons.faTrashAlt);
    library.add(SolidIcons.faUser);
    library.add(SolidIcons.faCog);
    dom.watch();
}
